import { render, staticRenderFns } from "./course-card.vue?vue&type=template&id=b7015c04&scoped=true&"
import script from "./course-card.vue?vue&type=script&lang=js&"
export * from "./course-card.vue?vue&type=script&lang=js&"
import style0 from "./course-card.vue?vue&type=style&index=0&id=b7015c04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7015c04",
  null
  
)

export default component.exports